/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Untitled_Event_GroupInputs */

const en_iframe_remote_untitled_event_group = /** @type {(inputs: Iframe_Remote_Untitled_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const fr_iframe_remote_untitled_event_group = /** @type {(inputs: Iframe_Remote_Untitled_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans titre`)
};

const de_iframe_remote_untitled_event_group = /** @type {(inputs: Iframe_Remote_Untitled_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Titel`)
};

const it_iframe_remote_untitled_event_group = /** @type {(inputs: Iframe_Remote_Untitled_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senza titolo`)
};

const ru_iframe_remote_untitled_event_group = /** @type {(inputs: Iframe_Remote_Untitled_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без названия`)
};

const es_iframe_remote_untitled_event_group = /** @type {(inputs: Iframe_Remote_Untitled_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intitulado`)
};

const zh_cn2_iframe_remote_untitled_event_group = /** @type {(inputs: Iframe_Remote_Untitled_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无题`)
};

const ja_iframe_remote_untitled_event_group = /** @type {(inputs: Iframe_Remote_Untitled_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無題`)
};

const hi_iframe_remote_untitled_event_group = /** @type {(inputs: Iframe_Remote_Untitled_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षकहीन`)
};

const pt_pt2_iframe_remote_untitled_event_group = /** @type {(inputs: Iframe_Remote_Untitled_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem título`)
};

/**
* | output |
* | --- |
* | "Untitled" |
*
* @param {Iframe_Remote_Untitled_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_untitled_event_group = /** @type {((inputs?: Iframe_Remote_Untitled_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Untitled_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_untitled_event_group(inputs)
	if (locale === "de") return de_iframe_remote_untitled_event_group(inputs)
	if (locale === "it") return it_iframe_remote_untitled_event_group(inputs)
	if (locale === "ru") return ru_iframe_remote_untitled_event_group(inputs)
	if (locale === "es") return es_iframe_remote_untitled_event_group(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_untitled_event_group(inputs)
	if (locale === "ja") return ja_iframe_remote_untitled_event_group(inputs)
	if (locale === "hi") return hi_iframe_remote_untitled_event_group(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_untitled_event_group(inputs)
	return en_iframe_remote_untitled_event_group(inputs)
});